exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alcohol-drug-abuse-form .mainTitle{margin:13px 0}.alcohol-drug-abuse-form .mainTitle h4{margin:0;font-size:24px;font-weight:500}.alcohol-drug-abuse-form .icons{background:#e5e7ef;border-radius:50%;height:35px;width:35px;padding:7px}.alcohol-drug-abuse-form .formElementTitle{font-size:.875rem;font-weight:500;line-height:1rem}@media(max-width: 575px){.alcohol-drug-abuse-form>form>.pre-quote-nav-control{margin-top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/AlcoholDrugAbuse.scss
// module id = 7552
// module chunks = 11